import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-book',
  templateUrl: './edit-book.component.html',
  styleUrls: ['./edit-book.component.scss']
})
export class EditBookComponent implements OnInit {
formData: any = {
  bookName: '',
  bookDescription: '',
  autherName: '',
  categoryId: null,
  subCategoryId: null,
  fileTypeId: '',
  imgFile: null,
  bookFile: null,
};
// Declare formData property 
    public arrCountries:any[] = [];
    public country:any[] = [];
      public currentPage = 1; 
  public categories : any
  public totalItems = 0;
subCategories: any[] = [];
editingSubCategoryName: string | null = null;
imagePreview: string | null = null;

  // imagePreview: string | ArrayBuffer | null = null;
bookFileName: string | null = null;
    constructor(private router: Router, private apisService: ApisService,
        private route: ActivatedRoute,    private loading : LoadingService
        ,private translate: TranslateService
    ) { }
  
    ngOnInit(): void {
          this.getMainCategories();

      // this.postCountires();
    const bookId = this.route.snapshot.paramMap.get('id');
  if (bookId) {
    this.fetchBookForEdit(+bookId);
  }
    }
fetchBookForEdit(id: number): void {
  this.apisService.getBookById(id).subscribe({
    next: (res: any) => {
      const book = res.data;

      this.formData.bookName = book.bookName;
      this.formData.bookDescription = book.bookDescription;
      this.formData.autherName = book.autherName;
      this.formData.fileTypeId = book.fileTypeId;
      this.formData.categoryId = book.categoryId;

      this.imagePreview = book.imgURL;
      this.bookFileName = book.bookURL ? book.bookURL.split('/').pop() : null;

      // 🔥 FETCH SUBCATEGORIES AND SET THE ID
      if (book.categoryId) {
        this.apisService.getMainSubCategories(book.categoryId).subscribe({
          next: (subRes: any) => {
            this.subCategories = subRes.data || [];

            // 🔥 FIND THE CORRECT SUBCATEGORY BY NAME AND SET THE ID
            const matchedSub = this.subCategories.find(
              (s: any) => s.subCategoryName === book.subCategory
            );

            if (matchedSub) {
              this.formData.subCategoryId = matchedSub.id; // now it will be selected automatically
            }
          },
          error: () => {
            this.subCategories = [];
          }
        });
      }
    },
    error: (err) => console.error(err)
  });
}


private loadSubCategoriesForEdit(categoryId: number, subCategoryName: string) {
  if (!categoryId) {
    this.subCategories = [];
    return;
  }

  this.apisService.getMainSubCategories(categoryId).subscribe({
    next: (res: any) => {
      this.subCategories = res.data || [];

      // 🔥 Wait until select is rendered
      setTimeout(() => {
        const matched = this.subCategories.find(
          (s: any) => s.subCategoryName === subCategoryName
        );

        if (matched) {
          this.formData.subCategoryId = matched.id;
        }
      });
    },
    error: () => {
      this.subCategories = [];
    }
  });
}


onCategoryChange(categoryId: number): void {
  if (!categoryId) {
    this.subCategories = [];
    this.formData.subCategoryId = null;
    return;
  }

  this.apisService.getMainSubCategories(categoryId).subscribe({
    next: (res: any) => {
      this.subCategories = res.data || [];
      console.log('SubCategories:', this.subCategories);
    },
    error: (err) => {
      console.error(err);
      this.subCategories = [];
    }
  });
}

 getMainCategories(){
      this.loading.show()
  this.apisService.getMainCategoriess().subscribe((res: any) => {
    this.loading.hide()
    this.categories = res.data;
    this.totalItems = this.categories.length;
  })
 }

onMainCategoryChange() {

  if (this.formData.categoryId) {
    this.apisService.getMainSubCategories(this.formData.categoryId).subscribe((res: any) => {
      this.subCategories = res.data;
    });
    // Reset subcategory when category changes
    this.formData.subCategoryId = null;
  }
}

    cancel(): void {
      this.router.navigate(['/settings/countries']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }

onFileSelected(event: any, type: 'img' | 'book') {
  const file = event.target.files[0];
  if (!file) return;

  if (type === 'img') {
    this.formData.imgFile = file;

    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  if (type === 'book') {
    this.formData.bookFile = file;
  }
}


 submitForm(): void {
  const formDataToSend = new FormData();

  formDataToSend.append('fileTypeId', String(this.formData.fileTypeId));
  formDataToSend.append('bookName', this.formData.bookName);
  formDataToSend.append('bookDescription', this.formData.bookDescription);
  formDataToSend.append('categoryId', String(this.formData.categoryId));
  formDataToSend.append('subCategoryId', String(this.formData.subCategoryId));
  formDataToSend.append('autherName', this.formData.autherName);
  // formDataToSend.append('imgURL', this.formData.imgFile); 
  // formDataToSend.append('bookURL', this.formData.bookFile); 

   if (this.formData.imgFile) {
    formDataToSend.append('imgURL', this.formData.imgFile);
  }

  if (this.formData.bookFile) {
    formDataToSend.append('bookURL', this.formData.bookFile);
  }

  // const id = 1; 
    const id = this.route.snapshot.paramMap.get('id'); // dynamic book id

  this.loading.show(); // ✅ Start loading


  this.apisService.editBook(+id, formDataToSend).subscribe({
    next: (res) => {
            this.loading.hide(); // ✅ Stop loading BEFORE alert

this.translate.get(['MENU.DASHBOARD.SUCCESS', 'MENU.DASHBOARD.BOOK_ADDED',  'MENU.DASHBOARD.OK'
]).subscribe(translations => {
   Swal.fire({
    title: translations['MENU.DASHBOARD.SUCCESS'],
    text: translations['MENU.DASHBOARD.BOOK_ADDED'],
    icon: 'success',
    confirmButtonText: translations['MENU.DASHBOARD.OK']
  }).then(() => {
          this.router.navigate(['/book']); // ✅ Navigate AFTER user clicks OK
        });
});
      // this.router.navigate(['/book']);
    },
    
  error: (err) => {
    console.error('Upload error:', err);

    const serverMessage = err?.error?.message || err?.message;

    this.translate.get([
      'MENU.DASHBOARD.ERROR',
      'MENU.DASHBOARD.UNEXPECTED_ERROR',
      'MENU.DASHBOARD.OK'
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['MENU.DASHBOARD.ERROR'],
        text: serverMessage || translations['MENU.DASHBOARD.UNEXPECTED_ERROR'],
        icon: 'error',
        confirmButtonText: translations['MENU.DASHBOARD.OK']
      });
    });
  }
});}

}

